import styles from "./mobileNavbar.module.scss";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HamburgerMenu from "../HamburgerMenu";
import { NavbarItems } from "../NavigationBar/types";
import AuthClient from "../../api/AuthClient";
import { routes } from "../../routes/routes";
import AppMode from "../../api/enums/AppMode";
import { getStoredAppMode, setStoredAppMode } from "../../utils/appMode";

interface NavigationBarProps {
  navLinkItem: NavbarItems[];
  cityName: string;
  handleLogout: () => void;
}

export default function LoggedMobileNavbar(props: NavigationBarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };
  const location = useLocation();
  const activePage = location.pathname;

  const authClient = new AuthClient();
  const user = authClient.getAuthenticationResponse();
  const userType = user?.userType.toString();

  const handleLogout = () => {
    props.handleLogout();
  };
  const navigate = useNavigate();
  const isOnGuestRoute = getStoredAppMode() === AppMode.GuestMode;

  const handleModeSwitch = () => {
    const nextMode = isOnGuestRoute ? AppMode.PromoterMode : AppMode.GuestMode;
    setStoredAppMode(nextMode);
    navigate(nextMode === AppMode.PromoterMode ? routes.PromotersMode : routes.GuestMode);
  };

  return (
    <div className={styles.navMenuContainer}>
      <HamburgerMenu onClick={toggleMenu} />

      {isOpen && (
        <div className={`${styles.navContainer} ${styles.navOpen}`}>
          <ul className={styles.navLinks}>
            {props.navLinkItem.map((item) => (
              <li
                className={`${activePage === item.path} ${styles.navLinkItem}`}
              >
                <Link
                  onClick={toggleMenu}
                  className={styles.navLink}
                  to={item.path}
                >
                  {item.path === routes.CitySelector ? props.cityName : item.title}
                </Link>
              </li>
            ))}

            {userType === "Promoter" && (
              <li onClick={handleModeSwitch}>
                <Link onClick={toggleMenu} to="#" className={styles.navLink}>
                  {isOnGuestRoute
                    ? "Switch to Promoter Mode"
                    : "Switch to Guest Mode"}
                </Link>
              </li>
            )}

            <li className={styles.navLinkItem}>
              <button
                type="button"
                className={styles.navLink}
                onClick={() => {
                  handleLogout();
                  toggleMenu();
                }}
              >
                Log Out
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
